/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import {PayloadRow} from '../../columns/PayloadRow'
import {EventDependentComponent} from '../areaContracts'
import intl from '../../utils/intl/intl'

export const DetailedViewTableView: EventDependentComponent = ({item}) => {
  const {discriminator1, discriminator2} = item
  return (
    <>
      {discriminator1 ? (
        <PayloadRow payloadKey={intl.formatMessage('Entity Type')} value={discriminator1} />
      ) : null}
      {discriminator2 ? (
        <PayloadRow payloadKey={intl.formatMessage('Process')} value={discriminator2} />
      ) : null}
    </>
  )
}
